export const isValidUrl = urlString => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    console.log('invalid url!');
    return false;
  }
};
